export default "__VITE_ASSET__BaLGmnps__ 640w, __VITE_ASSET__CDAKvvLh__ 1024w, __VITE_ASSET__BUllLZ8P__ 1536w";